import { render, staticRenderFns } from "./RoutesForm.vue?vue&type=template&id=bc3ac85c&scoped=true"
import script from "./RoutesForm.vue?vue&type=script&lang=js"
export * from "./RoutesForm.vue?vue&type=script&lang=js"
import style0 from "./RoutesForm.vue?vue&type=style&index=0&id=bc3ac85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ac85c",
  null
  
)

export default component.exports